var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuaranteeCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7361 0.706673C11.0604 1.00688 11.0896 1.52403 10.8013 1.86176L4.51563 9.22537C4.24415 9.54341 3.78387 9.59166 3.45696 9.33634L0.314117 6.88181C-0.0330319 6.61069 -0.103387 6.09785 0.156975 5.73636C0.417336 5.37486 0.909821 5.3016 1.25697 5.57272L3.82144 7.57556L9.62682 0.774619C9.91511 0.436889 10.4117 0.406469 10.7361 0.706673Z",
    fill: "#1377D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuaranteeCheck);
export default __webpack_public_path__ + "static/media/guarantee-check.c70e9a91bbc9cf8aaefb2e643985cd52.svg";
export { ForwardRef as ReactComponent };